import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import "./styles/Tancadas.css";

class Tancadas extends Component {
    state = {
        ordenId: null,
        modoLectura: true,
    };

    componentDidMount() {
        const { match } = this.props;
        const ordenId = match.params.id;

        // verificar el enlace para saber si es modoLectura o no
        const modoLectura = match.path.includes("detalle-tancadas");

        this.setState({ ordenId, modoLectura });
    }

    navigateToCargasTancada = (idTancada) => {
        const { history } = this.props;
        history.push(`/produccion-v2/cargas-tancada/${idTancada}`);
    };

    regresar = () => {
        const { history } = this.props;

        if (this.state.modoLectura) {
            history.goBack();
            return;
        }

        history.replace(
            `/produccion-v2/turnos-produccion?tab1=TURNO_ACTUAL&tab2=INICIADAS`,
        );
    };

    render() {
        const { user } = this.props;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Producción Sólidos"
                    subtitulo="Tancadas"
                    noBorder
                >
                    <Listado
                        ordenId={this.state.ordenId}
                        navigateToCargasTancada={this.navigateToCargasTancada}
                        regresar={this.regresar}
                        modoLectura={this.state.modoLectura}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(Tancadas);
